 /*jshint -W117 */
(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('UserOnboardController', UserOnboardController);

    /*jshint -W071, -W072 */
    /* @ngInject */
    function UserOnboardController($q, $state, $filter, $stateParams, $location, $anchorScroll,
        currentUser, userOnBoardingService, pendingUserService, userService, applicationService, customerService,
        $timeout, userTypeService, logger) {
        var vm = this;

        vm.loading = true;
        vm.showMap = false;

        vm.currentStep = null;

        vm.hasSmartTruckAppAccess = false;
        vm.showOrganizationStep = false;
        vm.canAddApplicationRoles = false;

        vm.editMode = false;
        vm.onBoard = userOnBoardingService.getDefaultOnBoard();
        vm.model = userOnBoardingService.getDefaultOnboardUser();
        vm.userTypes = [];
        vm.selectedUserType = null;
        vm.currentModel = null;
        vm.currentPermissions = null;
        vm.loggedInUserType = null;

        vm.showOrganizationStep = false;

        vm.applications = [];
        vm.viewableApplications = [];
        vm.userRoles = [];
        vm.currentRoles = [];

        vm.smartAppHiddenRoles = [];
        vm.validation = userOnBoardingService.getValidationObject();

        vm.refresh = refresh;
        vm.save = save;
        vm.redirect = redirect;
        vm.onApplicationAccessChanged = onApplicationAccessChanged;
        vm.onProfileValidationChanged = onProfileValidationChanged;
        vm.onOrganizationValidationChanged = onOrganizationValidationChanged;
        vm.onUserTypeValidationChanged = onUserTypeValidationChanged;
        vm.onUserTypeChanged = onUserTypeChanged;
        vm.onOrganizationChanged = onOrganizationChanged;
        vm.onTruckAccessValidationChanged = onTruckAccessValidationChanged;
        vm.onApplicationValidationChanged = onApplicationValidationChanged;
        vm.message = '';
        vm.messageAdditional = '';
        vm.isSuccess = true;

        activate();

        function activate() {
        /*jshint maxcomplexity:30 */
            vm.userId = parseInt($stateParams.userId) || null;
            vm.pendingId = parseInt($stateParams.pendingId) || null;

            var promises = [];

            vm.editMode = (vm.userId || vm.pendingId) !== null;

            if (!vm.userId || !vm.pendingId) {
                if (currentUser.isInRole('SSO:Site:Admin')) {
                    promises.push(currentUser.getUserSettings());
                }
            }

            // needed to display organization step etc
            promises.push(getLoggedInUserType(currentUser.psid), getSelectableUserTypesForLoggedInUser());

            if (vm.userId) {
                promises.push(getMasterUser(vm.userId));
                promises.push(getMasterUserRoles(vm.userId));
            }

            if (vm.pendingId) {
                vm.model.basic.SiteAddress = undefined;
                promises.push(getPendingUser(vm.pendingId).then(function () {
                    if (vm.userId) {
                        promises.push(getMasterUserRoles(vm.userId));
                    }
                }));
                promises.push(getPendingUserRoles(vm.pendingId));
            }

            $q.all(promises).then(function () {
                var appPromises = [];

                appPromises.push(getAllApplications(), getExistingApplications(vm.userId, vm.pendingId));

                if (!vm.showOrganizationStep) {
                    appPromises.push(getCustomerForCurrentUser(currentUser.userSettings.CustomerSiteId));
                }

                vm.selectedUserType = getSelectedUserType(vm.model.roles.UserTypeId);

                $q.all(appPromises).then(function () {
                    vm.loading = false;
                    validateAllSteps();
                });
            });
        }

        function validateAllSteps() {
            var isValid = vm.validation.roles && vm.validation.organization &&
                vm.validation.profile && vm.validation.trucks && vm.validation.permissions;

            vm.wizardIsEditable = isValid && vm.editMode;
            return isValid;
        }

        function save() {
            vm.onBoard.user = vm.model.basic;
            vm.onBoard.user.UserTypeId = vm.model.roles.UserTypeId;

            vm.onBoard.user = angular.extend(vm.onBoard.user, vm.model.profile);
            vm.onBoard.profile = vm.model.profile;
            vm.onBoard.settings = {
                SiteId: vm.model.organization.CustomerId,
                Sites: vm.model.roles.AutocarSites,
                TraffilogViewCustomerId: vm.model.organization.TraffilogViewCustomerId
            };
            vm.onBoard.applications = [];
            vm.onBoard.trucks = vm.model.trucks.Vins.length ? vm.model.trucks : null;

            angular.forEach(vm.model.permissions, function (app) {
                var roleIds = [];
                if (app.HasAccess) {
                    angular.forEach(app.SelectedRoles, function (selectedRole) {
                        roleIds.push(selectedRole.RoleId);
                    });
                }
                vm.onBoard.applications.push({
                    HasAccess: app.HasAccess,
                    ApplicationId: app.ApplicationId,
                    Roles: roleIds
                });
            });

            userOnBoardingService.saveOnBoardUser(vm.onBoard)
                .then(function (result) {
                    ATAC.hideLoader();
                    if (result.status !== 200) {
                        logger.info('issue saving user');

                        vm.message = 'issue saving user';
                        vm.isSuccess = false;

                    } else if (result.data && result.data.TraffilogBoomi && result.data.TraffilogBoomi.IsSynced) {
                        if (result.data.TraffilogBoomi.IsSuccess) {
                            logger.info('Save and sync with Trafflog was successful');
                            redirect();

                        } else {
                            vm.isSuccess = true;
                            vm.message = 'Save was successful';
                            vm.messageAdditional = ' Sync with Trafflog was failed: ' +
                                result.data.TraffilogBoomi.Description;
                        }

                    } else {
                        logger.info('Save was successful');
                        redirect();
                    }

                }, handleException);
        }

        function handleException(error) {
            ATAC.hideLoader();

            vm.isSuccess = false;

            var message = error.message;

            if (!message) {
                message = (error.data && error.data.ExceptionMessage) ? error.data.ExceptionMessage : message;
            }

            if (!message) {
                message = 'issue saving user';
            }

            vm.message = message;
        }

        function redirect() {
            $timeout(function() {
                    if (vm.pendingId !== null) {
                        $state.go('user.pending');
                    } else {
                        $state.go('user.dashboard');
                    }
                },1000);
        }

        function getLoggedInUserType(userId) {
            return userTypeService.getUserTypeByUserId(userId).then(function (result) {
                if (result.status === 200) {
                    vm.showOrganizationStep = result.data.CanViewOrganization;
                    vm.canAddApplicationRoles = result.data.CanModifyApplicationRoles;
                    vm.loggedInUserType = result.data;
                }
            });
        }

        function getSelectableUserTypesForLoggedInUser() {
            return userTypeService.getUserTypeForLoggedInUser().then(function (userTypes) {
                if (userTypes.status === 200) {
                    vm.userTypes = userTypes.data;
                }
            });
        }

        function getSelectedUserType(userTypeId) {
            return _.find(vm.userTypes, { UserTypeId: userTypeId }) || null;
        }

        function getMasterUser(userId) {
            /*jshint maxcomplexity:30 */
            return userService.getUser(userId).then(function (result) {
                result.SiteId = result.UserSettings !== null ? result.UserSettings.CustomerSiteId : null;
                result.Profile = userOnBoardingService.mapProfileUsingUserDetails(result);

                var isADUser = result.ConnectionType.ConnectionTypeId === 1;

                vm.showTruckAccessStep = result.UserType !== null ?
                    result.UserType.CanViewLimitedTrucks : false;

                result.UserTruckTies = result.UserTruckTies.length ?
                    result.UserTruckTies.map(function (truckTie) {
                        return truckTie.Truck.ShortVIN;
                    }) : [];

                if (vm.pendingId !== null) {
                    vm.currentModel = userOnBoardingService.getDefaultOnboardUser();

                    configureBasicInformationStep(vm.currentModel.basic, result);
                    configureUserRolesStep(vm.currentModel.roles,
                        userOnBoardingService.mapUserRolesInformation(result, isADUser));
                    configureProfileStep(vm.currentModel.profile, result.Profile, isADUser);

                    if (result.SiteId) {
                        configureOrganizationStep(vm.currentModel.organization, result.UserSettings);
                    }

                    if (result.SiteId) {
                        configureTruckAccess(vm.currentModel.trucks, result.UserTruckTies,
                            vm.model.organization, result.UserType);
                    }

                    vm.model.basic.Auth0UserId = result.Auth0UserId;
                    vm.model.roles.AutocarSites = vm.currentModel.roles.AutocarSites;
                } else {

                    configureBasicInformationStep(vm.model.basic, result);

                    configureUserRolesStep(vm.model.roles,
                        userOnBoardingService.mapUserRolesInformation(result, isADUser));

                    configureProfileStep(vm.model.profile, result.Profile, isADUser);

                    if (result.SiteId) {
                        configureOrganizationStep(vm.model.organization, result.UserSettings);
                    }

                    if (result.SiteId) {
                        configureTruckAccess(vm.model.trucks, result.UserTruckTies,
                            vm.model.organization, result.UserType);
                    }
                }
            });
        }

        function getMasterUserRoles(userId) {
            return pendingUserService.getApplicationAccessAndRolesForMasterUser(userId).then(function (result) {
                if (vm.pendingId) {
                    vm.currentRoles = result;
                } else {
                    vm.userRoles = result;
                }
            });
        }

        function getPendingUser(pendingUserId) {
            return pendingUserService.getPendingUser(pendingUserId).then(function (result) {
                if (result.length > 0) {
                    result[0].ConnectionType = {
                        ConnectionTypeId: 2
                    };

                    vm.model.basic = userOnBoardingService.mapBasicInformationModel(result[0]);
                    configureUserRolesStep(vm.model.roles,
                        userOnBoardingService.mapUserRolesInformation(result[0], false));
                    configureProfileStep(vm.model.profile,
                        userOnBoardingService.mapPendingProfileInformation(result[0]), false);

                    if (result[0].SiteId) {
                        configureOrganizationStep(vm.model.organization,
                            userOnBoardingService.mapPendingOrganizationInformation(result[0]));
                    }

                    if ((vm.model.roles.IsCustomer && vm.model.roles.CustomerType === 'Customer') &&
                            !!result[0].SiteId) {
                        var trucks = [];
                        angular.forEach(result[0].UserTruckTie, function (truck) {
                            trucks.push(truck.Truck.ShortVIN);
                        });

                        configureTruckAccess(vm.model.trucks, trucks, vm.model.organization);
                    }

                    if (result[0].UserId) {
                        vm.userId = result[0].UserId;
                        getMasterUser(vm.userId);
                    }
                }
            });
        }

        function getPendingUserRoles(pendingUserId) {
            return pendingUserService.getRolesForPendingUser(pendingUserId).then(function (result) {
                var roles = [];
                angular.forEach(result, function (pendingRoles) {
                    roles.push({
                        RoleId: pendingRoles.Role.SSORoleId,
                        ApplicationId: pendingRoles.Role.ApplicationId,
                        RoleName: pendingRoles.Role.LegacyRoleName
                    });
                });

                vm.userRoles = roles;
            });
        }

        function configureBasicInformationStep(model, basic) {
            if (!basic) { return; }

            model = angular.extend(model, userOnBoardingService.mapBasicInformationModel(basic));
        }

        function configureUserRolesStep(model, roles) {
            if (!roles) { return; }

            model = angular.extend(model, {
                UserTypeId: roles.UserTypeId,
                IsADUser: roles.IsADUser,
                AutocarSites: roles.AutocarSites
            });

            vm.validation.roles = model.UserTypeId > 0 && (model.IsADUser ? model.AutocarSites.length > 0: true);
        }

        function configureOrganizationStep(model, organization) {
            if (!organization) { return; }

            model = angular.extend(model, {
                CustomerId: organization.CustomerSiteId,
                CustomerDisplayName: organization.Site.CustomerDisplayName,
                Name: organization.Site.Name,
                Zoom: 17,
                Center: { lat: 15, lng: 15 },
                TraffilogViewCustomerId: organization.TraffilogViewCustomerId,
                TraffilogViewCustomerDisplayName: organization.TraffilogViewCustomer ?
                    organization.TraffilogViewCustomer.CustomerDisplayName : '',
                TraffilogViewCustomerName: organization.TraffilogViewCustomer ?
                    organization.TraffilogViewCustomer.Name : ''
            });

            vm.validation.organization = model.CustomerId && model.CustomerDisplayName !== '';
        }

        function configureProfileStep(model, profile, isADUser) {
            if (!profile) { return; }

            model = angular.extend(model, userOnBoardingService.mapProfileInformation(profile));

            if (isADUser) {
                vm.validation.profile = model.Email !== '' && model.FirstName !== '' &&
                    model.LastName !== '';
            } else {
                vm.validation.profile = model.Email !== '' && model.FirstName !== '' &&
                    model.LastName !== '' && model.LocationRoleId > 0 && model.DepartmentRoleId > 0 &&
                    model.TitleRoleId > 0;
            }

        }

        function configureTruckAccess(model, access, organization, userType) {
            if (!access) { return; }

            model = angular.extend(model, {
                CustomerId: organization.CustomerId,
                CustomerName: organization.CustomerDisplayName,
                Vins: access
            });

            vm.validation.trucks = !!userType && userType.CanViewLimitedTrucks ? model.Vins.length > 0: true;
        }

        function getAllApplications() {
            var query;

            query = applicationService.getAllApplications();

            return query
                .then(function (result) {
                    var viewableApplications = vm.loggedInUserType.CanViewAllApplications ? result : [];

                    angular.forEach(result, function (item) {
                        /*jshint maxcomplexity:60 */
                        item.canViewRoles = vm.canAddApplicationRoles;

                        item.access = false;
                        item.edited = false;
                        item.selectedRoles = [];

                        angular.forEach(vm.userRoles, function (role) {
                            if (role.RoleId) {
                                if (role.ApplicationId === item.ApplicationId) {
                                    angular.forEach(item.Roles, function (appRole) {
                                        if (appRole.RoleId === role.RoleId) {
                                            item.access = true;
                                            item.selectedRoles.push(appRole);
                                        }
                                    });
                                }
                            } else {
                                if (role.ApplicationId === item.ApplicationId) {
                                    item.access = true;
                                }
                            }
                        });

                        item.original = {
                            access: item.access,
                            selectedRoles: item.selectedRoles,
                            edited: item.edited
                        };

                        vm.model.permissions.push(angular.copy({
                            ApplicationId: item.ApplicationId,
                            ApplicationName: item.ApplicationName,
                            HasAccess: item.access,
                            SelectedRoles: item.selectedRoles,
                            CanViewRoles: item.canViewRoles
                        }));
                    });

                    if (!vm.loggedInUserType.CanViewAllApplications && vm.selectedUserType) {
                        angular.forEach(vm.selectedUserType.DefaultApplications, function (defaultApp) {
                            var app = _.find(result, { ApplicationId: defaultApp.ApplicationId });
                            if (app) {
                                viewableApplications.push(app);
                            }
                        });
                    }

                    vm.applications = result;
                    vm.viewableApplications = viewableApplications;
                });
        }

        function getExistingApplications(userId, pendingId) {
            if (!!userId && !!pendingId) {
                return applicationService.getUserApplicationsWithAllRoles(userId)
                    .then(function (result) {

                        angular.forEach(result, function (app) {
                            app.access = false;
                            var rolesMatched = [];
                            angular.forEach(app.Roles, function (appRole) {
                                if (vm.currentRoles.length) {
                                    var role = $filter('filter')(vm.currentRoles,
                                        { RoleId: appRole.RoleId }, true);

                                    if (role.length > 0) {
                                        app.access = true;
                                        rolesMatched.push(appRole);
                                    }
                                }
                            });
                            app.Roles = rolesMatched;
                            app.UserApplicationTies = [];
                        });
                        vm.currentPermissions = result;
                    });
            }
        }

        function hasUserGotAccessToApplication(applicationId) {
            return _.find(vm.model.permissions, function (app) {
                return app.ApplicationId === applicationId;
            });
        }

        function getApplicationById(applicationId) {
            return _.find(vm.viewableApplications, function (app) {
                return app.ApplicationId === applicationId;
            });
        }

        function getCustomerForCurrentUser(siteId) {
            return customerService.getCustomer(siteId).then(function (results) {
                if (results.length) {
                    var customer = results[0];
                    vm.model.organization = angular.extend(vm.model.organization, {
                        CustomerId: customer.CustomerID,
                        CustomerDisplayName: customer.CustomerDisplayName,
                        Name: customer.Name
                    });

                    vm.model.trucks = angular.extend(vm.model.trucks, {
                        CustomerId: customer.CustomerID,
                        CustomerName: customer.CustomerDisplayName
                    });
                }
            });
        }

        // EVENTS
        function onProfileValidationChanged(isValid) {
            vm.validation.profile = isValid;
        }

        function onOrganizationValidationChanged(isValid) {
            vm.validation.organization = isValid;
        }

        function onOrganizationChanged(organization) {
            vm.model.roles = angular.extend(vm.model.roles, {
                CustomerType: vm.model.roles.IsCustomer ? (organization.IsDistributor ? 'Dealer' : 'Customer') :
                    'Autocar'
            });

            vm.model.trucks = angular.extend(vm.model.trucks, {
                CustomerId: organization.CustomerId,
                CustomerName: organization.CustomerDisplayName
            });

            if (vm.model.roles.IsCustomer) {
                onUserTypeChanged('Customer');
            }
        }

        function onUserTypeValidationChanged(isValid) {
            vm.validation.roles = isValid;
        }

        function onUserTypeChanged(userType, override) {
            vm.selectedUserType = angular.copy(userType);
            var newConnectionTypeId = userType.IsADUser ? 1 : 2;
            if (vm.model.basic.ConnectionTypeId !== newConnectionTypeId && !vm.editMode) {
                angular.extend(vm.model.profile, {
                    FirstName: '',
                    LastName: '',
                    FullName: '',
                    Auth0UserId: '',
                    Email: '',
                    LocationRoleId: null,
                    DepartmentRoleId: null,
                    TitleRoleId: null
                });

                vm.validation.profile = false;
            }

            vm.showTruckAccessStep = userType.CanViewLimitedTrucks;

            vm.model.basic.ConnectionTypeId = newConnectionTypeId;

            if (!vm.editMode || override) {
                reconcileApplicationAccessOnUserChange(userType);

                angular.forEach(userType.DefaultApplications, function (defaultApp) {

                    var application = getApplicationById(defaultApp.ApplicationId);
                    var existingPermissions = hasUserGotAccessToApplication(defaultApp.ApplicationId);

                    if (application) {
                        angular.forEach(defaultApp.Roles, function (defaultRoleId) {
                            addRoleToApplication(application, defaultRoleId);
                            addRoleToExistingPermissions(application, existingPermissions, defaultRoleId);
                        });

                        var copyOfApplicationRoles = angular.copy(application.selectedRoles.map(function (role) {
                            return role.RoleId;
                        }));
                        var rolesToRemove = _.difference(copyOfApplicationRoles, defaultApp.Roles);

                        angular.forEach(rolesToRemove, function (removableRoleId) {
                            removeRoleFromApplication(application, removableRoleId);
                            removeRoleFromExistingPermissions(existingPermissions, removableRoleId);
                        });

                        application.access = true;
                        existingPermissions.HasAccess = true;
                    }
                });
            }
        }

        function reconcileApplicationAccessOnUserChange(userType) {
            setViewableApplications();

            var copyOfApplications = angular.copy(vm.viewableApplications.map(function (app) {
                return app.ApplicationId;
            }));
            var copyOfDefaultApps = angular.copy(userType.DefaultApplications.map(function (app) {
                return app.ApplicationId;
            }));

            var applicationsToRemove = _.difference(copyOfApplications, copyOfDefaultApps);
            angular.forEach(applicationsToRemove, function (removableApplicationId) {
                removeApplicationAccess(removableApplicationId);
                removeApplicationFromExistingPermissions(removableApplicationId);
            });
        }

        function setViewableApplications() {
            var viewableApplications = [];
            angular.forEach(vm.selectedUserType.DefaultApplications, function (defaultApp) {
                var app = _.find(vm.applications, { ApplicationId: defaultApp.ApplicationId });
                if (app) {
                    viewableApplications.push(app);
                }
            });
            vm.viewableApplications = vm.loggedInUserType.CanViewAllApplications ?
                vm.applications : viewableApplications;
        }

        function removeApplicationAccess(applicationId) {
            var application = _.find(vm.viewableApplications, { ApplicationId: applicationId });
            if (application) {
                application.access = false;
                application.selectedRoles = [];
            }
        }

        function removeApplicationFromExistingPermissions(applicationId) {
            var application = _.find(vm.model.permissions, { ApplicationId: applicationId });
            if (application) {
                application.HasAccess = false;
                application.SelectedRoles = [];
            }
        }

        function addRoleToApplication(application, roleId) {
            var hasRole = _.some(application.selectedRoles, function (role) {
                return role.RoleId === roleId;
            });

            if (!hasRole) {
                var roleToAdd = _.find(application.Roles, { RoleId: roleId });
                if (roleToAdd) {
                    application.selectedRoles.push(angular.copy(roleToAdd));
                }
            }

            vm.viewableApplications = angular.extend(vm.viewableApplications, application);
        }

        function addRoleToExistingPermissions(application, existingApplicationPermissions, roleId) {
            var hasRole = _.some(existingApplicationPermissions.SelectedRoles, function (role) {
                return role.RoleId === roleId;
            });

            if (!hasRole) {
                var roleToAdd = _.find(application.Roles, { RoleId: roleId });
                if (roleToAdd) {
                    existingApplicationPermissions.SelectedRoles.push(angular.copy(roleToAdd));
                }
            }

            vm.model.permissions = angular.extend(vm.model.permissions, existingApplicationPermissions);
        }

        function removeRoleFromApplication(application, roleId) {
            var remainingRoles = _.reject(application.selectedRoles, function (rejected) {
                return rejected.RoleId === roleId;
            });

            application.selectedRoles = remainingRoles;
            vm.viewableApplications = angular.extend(vm.viewableApplications, application);
        }

        function removeRoleFromExistingPermissions(existingPermissions, roleId) {
            var remainingRoles = _.reject(existingPermissions.SelectedRoles, function (rejected) {
                return rejected.RoleId === roleId;
            });

            existingPermissions.SelectedRoles = remainingRoles;
            vm.model.permissions = angular.extend(vm.model.permissions, existingPermissions);
        }

        function onApplicationAccessChanged() {
            var smartApp = _.where(vm.model.permissions, { ApplicationId: vm.smartAppId });
            if (smartApp.length) {
                vm.hasSmartTruckAppAccess = smartApp[0].HasAccess;
            } else {
                vm.hasSmartTruckAppAccess = false;
            }
        }

        function onTruckAccessValidationChanged(isValid) {
            vm.validation.trucks = isValid;
        }

        function onApplicationValidationChanged(isValid) {
            vm.validation.permissions = isValid;
        }

        //hack to make the multiple selects update the input width
        function refresh() {
            scrollBackToTop('atac_top-menu');
            $timeout(function () { }, 50);
        }

        function scrollBackToTop(element) {
            $location.hash(element);
            $anchorScroll();
        }
    }
})();
